/*global _wa: false, YT: false*/
"use strict";

import Semver from 'semver';

AndApp.appDetail = {

  init() {
    const apiTag = document.createElement("script");
    apiTag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(apiTag, firstScriptTag);
  },

  youtubePlayer: null,
  youtubePlayBtn: $("#js-moviePlay"),
  youtubePoster: $("#js-moviePoster"),
  youtubeMovieChooser: {
    thumbs: $('.js-movie-thumb'),
    nextMovie() {
      const self = this;
      const current = self.thumbs.parent().find(".is-active:first");
      let next = current.next();
      if (next.length === 0) {
        next = self.thumbs.first();
      }
      self.setActiveThumb(next);
    },
    setActiveThumb(thumb) {
      const self = this;
      if ($(thumb).is('.is-active') || !$(thumb).is('.js-movie-thumb')) {
        return;
      }
      const videoId = $(thumb).data('videoid');

      $('.js-movie-thumb.is-active').removeClass('is-active');
      $(thumb).addClass('is-active');
      AndApp.appDetail.youtubePlayer.setMovie(videoId);
    }
  },
  setYoutubePlayer() {
    const self = this;
    self.youtubePlayer = {
      player: null,
      setOption(videoId) {
        const options = {
          width: 690,
          height: 388,
          videoId,
          playerVars: {
            rel: 0,
            showinfo: 1,
            wmode: 'transparent',
            modestbranding: 1
          },
          events: {
            "onReady": this.onReady,
            "onStateChange": this.onStateChange
          }
        };
        return options;
      },
      onReady() {
        // youtubeのiframeとバッティング？するバグ対策として
        // playerのonReadyでtwitterのapiを呼び出す
        setTwitterWidgets();
      },
      onStateChange(event) {
        if (event.data === YT.PlayerState.PLAYING) {
          self.youtubePlayBtn.css({display: "none"});
          self.youtubePoster.fadeOut(1500, 'swing');
        } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.CUED) {
          if (event.data === YT.PlayerState.ENDED) {
            AndApp.appDetail.youtubeMovieChooser.nextMovie();
          }
          self.youtubePlayBtn.css({display: "block"});
          self.youtubePoster.fadeIn(500);
        }
      },
      play(event) {
        this.player.playVideo();
      },
      setMovie(movieId) {
        self.youtubePoster.attr('src', `https://i.ytimg.com/vi/${  movieId  }/maxresdefault.jpg`);
        if (this.player) {
          this.player.cueVideoById(movieId);
        } else {
          this.player = new YT.Player('js-movie', this.setOption(movieId));
        }
        self.youtubePlayBtn.click(function() {
          self.youtubePlayBtn.css({display: "none"});
          self.youtubePoster.fadeOut(1500, 'swing');
          AndApp.appDetail.youtubePlayer.play();
        });
      }
    };
  },

  // [MEMO]スマホはギャラリー部分がjs制御でなくなったので処理を分岐させるためのフラグ（暫定対応）
  // ※ タブレットはPC側の処理
  enableGallery: AndApp.Device.isPC() || AndApp.Device.isAndAppClient(),
  gallery: $(".js-scrollpanel"),
  galleryPrev: $(".js-galleryPrev"),
  galleryNext: $(".js-galleryNext"),
  galleryItems: $(".js-galleryList"),
  setGallery() {
    const self = this;
    const galleryItemsHeight = self.galleryItems.innerHeight();

    self.galleryItems.innerHeight(Math.floor(galleryItemsHeight));

    self.gallery.jScrollPane({
      animateScroll: true
    });
    const scrollApi = self.gallery.data("jsp");
    self.setButton();
    self.galleryPrev.unbind("click");
    self.galleryNext.unbind("click");
    self.galleryPrev.bind("click", function() {
      scroll("prev");
    });
    self.galleryNext.bind("click", function() {
      scroll("next");
    });
    self.gallery.bind("jsp-scroll-x", function() {
      window.setTimeout(function() { self.setButton(); }, 300);
    });
    function scroll(direction) {

      const isLandscape = self.galleryItems.hasClass("landscape");
      const current =  Math.round(scrollApi.getContentPositionX());
      const imageWidth = isLandscape ? 540 : 270;
      let diff = isLandscape ? 540 : 270;

      if (current === 0 || current % imageWidth === 0) {
        diff = imageWidth;
      } else {
        diff = imageWidth - current % imageWidth;
      }

      if (direction === "prev") {
        if (diff === imageWidth) {
          diff = -diff;
        } else {
          diff -= imageWidth;
        }
      }
      scrollApi.scrollToX(current + diff);
      window.setTimeout(function() { self.setButton(); }, 300);
    }

  },
  setButton() {
    const self = this;
    const scrollApi = self.gallery.data("jsp");
    if (scrollApi.getIsScrollableH()) {
      self.galleryNext.removeClass("is-disabled");
      self.galleryPrev.removeClass("is-disabled");
      if (scrollApi.getPercentScrolledX() === 0) {
        self.galleryPrev.addClass("is-disabled");
      } else if (scrollApi.getPercentScrolledX() > 0.999)  {
        self.galleryNext.addClass("is-disabled");
      }
    } else {
      self.galleryPrev.addClass("is-disabled");
      self.galleryNext.addClass("is-disabled");
    }
  },
  getAppId() {
    const v = window.location.pathname.split("/");
    return v.length > 0 ? Number(v[v.length - 1]) : 0;
  },
  playnowClicked(button) {
    if (!button.data('showModal') && button.data('href')) {
      this.sendEvents("play");
      window.open().location.href = button.data('href');
    }
  },
  showClientUpdateModal() {
    $('.js-modalTrigger').addClass('is-openModal');
    $('.js-client-update-modal-close').off().click(() => {
      this.closeClientUpdateModal();
    });
  },
  closeClientUpdateModal() {
    $('.js-modalTrigger').removeClass('is-openModal');
  },

  setPlayMenuButtonAs(btn, isPCApp) {
    const self = this;
    $('.playmenu .js-button').addClass('is-hidden').removeClass("is-disabled");

    if (!isPCApp) {
      // must be playnow if not pcapp
      $('.playmenu .js-button-playnow').removeClass('is-hidden');
      return;
    }

    switch (btn) {
      case 'download':
        if ($('body').data('isInstallable')) {
          $('.playmenu .js-button-download').removeClass('is-hidden');
        } else {
          $('.playmenu .js-button-maintenance').removeClass('is-hidden');
        }
        break;
      case 'playnow':
        $('.playmenu .js-button-playnow').removeClass('is-hidden');
        break;
      case 'downloading':
        $('.playmenu .js-button-downloading').removeClass('is-hidden');
        break;
      case 'maintenance':
        $('.playmenu .js-button-maintenance').removeClass('is-hidden');
        break;
      default:
        $('.playmenu .js-button-playnow').removeClass('is-hidden');
        console.error(`unknown button type: ${ btn }`);
        break;
    }

  },
  setPlayMenuButton() {
    const self = this;

    const platform = $('body').data('platform');
    if (typeof platform === "undefined") {
      return;
    }
    self.setPlayMenuButtonAs('playnow', false);
    const onPlaynowModalButtonClick = function() {
      AndApp.appDetail.sendEvents($(this).data('event'));
      window.location.href = $(this).data('href');
    };
    $("#js-modal-playnow-download").click(onPlaynowModalButtonClick);
    $("#js-modal-playnow-gamestart").click(onPlaynowModalButtonClick);

    $('.js-button-playnow').each(function(index) {
      if ($(this).data('showModal')) {
        $(this).colorbox({
          inline: true,
          href: "#js-modal-playnow",
          close: "",
          fixed: true
        });
        $(this).click(function() {
          AndApp.appDetail.sendEvents("play");
        });
      }
    });
  },
  sendEvents(eventName) {
    // yahoo tag manager
    AndApp.appDetail.sendYahooTagManagerEvent();
  },
  sendYahooTagManagerEvent() {
    const tagjs = document.createElement("script");
    const s = document.getElementsByTagName("script")[0];
    tagjs.async = true;
    tagjs.src = "//s.yjtag.jp/tag.js#site=k36tMgw";
    s.parentNode.insertBefore(tagjs, s);
  }
};

function setTwitterWidgets() {
  window.twttr = (function(d, s, id) {
    let js, fjs = d.getElementsByTagName(s)[0],
      t = window.twttr || {};
    if (d.getElementById(id)) { return t; }
    js = d.createElement(s);
    js.id = id;
    js.src = "https://platform.twitter.com/widgets.js";
    fjs.parentNode.insertBefore(js, fjs);

    t._e = [];
    t.ready = function(f) {
      t._e.push(f);
    };

    return t;
  }(document, "script", "twitter-wjs"));
}

global.onYouTubeIframeAPIReady = () => {
  if (document.getElementById("js-movie")) {
    AndApp.appDetail.setYoutubePlayer();
    AndApp.appDetail.youtubePlayer.setMovie(document.getElementById("js-movie").getAttribute("data-videoid"));

    // Movie chooser
    AndApp.appDetail.youtubeMovieChooser.thumbs.click(function(ev) {
      AndApp.appDetail.youtubeMovieChooser.setActiveThumb(this);
      AndApp.appDetail.youtubePlayer.play();
    });
  }
};

(function() {
  AndApp.appDetail.init();

  const toggleHeader = () => {
    const $fixedHeader = $(".js-fixedHeader");
    const switchHeight = $(".js-holdHeader").outerHeight() + $(".js-appNavigation").outerHeight();
    let isShow = false;

    if ($(window).scrollTop() >= switchHeight) {
      if (!isShow) {
        $fixedHeader.removeClass("is-hidden");
        isShow = true;
      }
    } else {
      $fixedHeader.addClass("is-hidden");
      isShow = false;
    }
  };

  const main = function() {

    // init movie thumbs(if exists)
    $('.js-movie-thumb').first().addClass('is-active');
    if (AndApp.appDetail.enableGallery) {
      // gallery set
      const galleryImage = $(".js-galleryList img")[0];
      if (galleryImage.width > galleryImage.height) {
        $(".js-galleryList").addClass("landscape");
      }

      // init color box
      $("a.galleryItemImage").colorbox({
        rel: "gallery",
        previous: "",
        next: "",
        close: "",
        initialWidth: 250,
        initialHeight: 640,
        fixed: true,
        scalePhotos: true,
        maxWidth: '90%',
        maxHeight: '90%'
      });
    }

    const objModal = document.getElementById("js-modalWrapper");
    if (objModal !== null) {
      if ($(objModal).hasClass("js-isSp")) {
        //sp
        $(".js-registMail").colorbox({
          inline: true,
          href: "#js-modal-form",
          close: "",
          fixed: true,
          width: "100%",
          height: "100%",
          maxWidth: "100%",
          maxHeight: "100%",
          transition: "none",
          className: "cboxOverlaySp"
        });
        $(".js-notice").colorbox({
          inline: true,
          href: "#js-modal-notice",
          close: "",
          fixed: true,
          width: "100%",
          height: "100%",
          maxWidth: "100%",
          maxHeight: "100%",
          transition: "none",
          className: "cboxOverlaySp"
        });
        // ▼モーダルをスクロールしたときに背景のページがスクロールするのを防ぐ
        let scrollTop = 0;
        const disableScroll = () => {
          scrollTop = $(window).scrollTop();
          $(".c-viewport").css({
            "position": "fixed",
            "top": -scrollTop
          });
        };
        const enableScroll = () => {
          $(".c-viewport").css({
            "position": "",
            "top": ""
          });
          $(window).scrollTop(scrollTop);
        };
        $(document).on({
          "cbox_open": () => { // モーダル開くとき
            disableScroll();
          },
          "cbox_cleanup": () => { // モーダル閉じるとき
            enableScroll();
          }
        });
        // ▼スマホの向き変更に対応
        $(window).on("resize", () => {
          $.colorbox.resize({
            width: "100%",
            height: "100%",
            innerWidth: "100%",
            innerHeight: "100%"
          });
        });
      } else {
        //pc
        $(".js-registMail").colorbox({
          inline: true,
          href: "#js-modal-form",
          close: "",
          fixed: true
        });
        $(".js-notice").colorbox({
          inline: true,
          href: "#js-modal-notice",
          close: "",
          fixed: true
        });
        $(".js-notsupported-forapp").colorbox({
          inline: true,
          href: "#js-modal-notsupported-forapp",
          close: "",
          fixed: true
        });
        $(".js-notsupported").colorbox({
          inline: true,
          href: "#js-modal-notsupported",
          close: "",
          fixed: true
        });
      }
    }

    // not movie
    if (document.getElementById("js-imageViewer")) {
      $("#js-imageViewer").bxSlider({
        auto: true,
        speed: 1000,
        mode: 'fade',
        pager: false,
        controls: false
      });

      // imageViewerの場合はここでtwitter widgetを読み込んでおく
      // ※ movieの場合は動画プレイヤーのonReadyのタイミングで読み込み
      setTwitterWidgets();
    }


    // toggle header
    window.addEventListener("scroll", toggleHeader);
    window.addEventListener("resize", toggleHeader);
    toggleHeader();

    $('.js-button-playnow').click(function() {
      AndApp.appDetail.playnowClicked($(this));
    });
  };

  const showModal = function() {
    const objModal = document.getElementById("js-modalWrapper");

    if (objModal !== null) {
      const regErrorStatus = $("#js-regErrorStatus").val();
      const regCallBack = $("#js-regCallBack").val();

      if (regCallBack === "true") {
        let modalTarget;
        switch (regErrorStatus) {
          case "has_registered":
            modalTarget = "#js-modal-already";
            break;
          case "unknown":
            modalTarget = "#js-modal-err";
            break;
          case "":
            modalTarget = "#js-modal-done";
            break;
          default:
            return;
        }
        if (!$(objModal).hasClass("js-isSp")) {
          $.colorbox({
            inline: true,
            href: modalTarget,
            fixed: true,
            close: "",
            scrolling: false,
            open: true
          });
        } else if (modalTarget !== "#js-modal-done") {
          $.colorbox({
            inline: true,
            href: modalTarget,
            fixed: true,
            close: "",
            open: true,
            width: "100%",
            className: "cboxOverlaySp",
            scroll: false
          });
        }
      }
    }
  };

  $(document).ready(function() {
    AndApp.appDetail.setPlayMenuButton();

    showModal();
  });
  $(window).load(function() {
    main();
    if (AndApp.appDetail.enableGallery) {
      AndApp.appDetail.setGallery();
    }
  });
  if (AndApp.appDetail.enableGallery) {
    let timer = false;
    $(window).resize(function() {
      if (timer !== false) {
        clearTimeout(timer);
      }
      timer = setTimeout(function() {
        AndApp.appDetail.setGallery();
      }, 200);
    });
  }
}());

$(function() {

  // infoの「もっと見るボタン」を出すか出さないか判断
  const lineHeight = parseInt($("#js-appDetail_information_description").css("line-height"));
  const linesToShow = 4;
  const maxHeight = lineHeight * linesToShow;
  // 確実に5行から「もっとみる」を出すために、本文のheightから半行分を引いた数値と4行分の数値を比較するようにした。
  const descriptionHeight = parseInt($("#js-appDetail_information_description").height()) - lineHeight / 2;

  if (descriptionHeight > maxHeight) {
    $("#js-appDetail_information_description").css("height", `${maxHeight  }px`);
    $("#js-appDetail_information_moreButton").show();

    $("#js-appDetail_information_more").click(function() {
      $("#js-appDetail_information_description").css("height", "auto");
      $("#js-appDetail_information_moreButton").hide();
    });
  }

  // smoothScroll
  $('nav a[href^="#"]').smoothScroll({
    offset: 90
  });
});
